import {environment} from "../../environments/environment";

export class Constants {
  private static tenantId: string;
  private static origin: string;
  private static serverUrl: string = "https://devapi.saasmax.com/";
  private static prodServerUrl: string = "https://api.saasmax.com/";
  private static bucketUrl: string = "https://s3.amazonaws.com/saasmaxstaging/";
  private static postAffiliateProUrl: string = "https://saasmax.postaffiliatepro.com/";
  public static router: any;
  private static countries = ["AALAND ISLANDS" , "AFGHANISTAN" , "ALBANIA" , "ALGERIA" , "AMERICAN SAMOA" ,
    "ANDORRA" , "ANGOLA" , "ANGUILLA" , "ANTARCTICA" , "ANTIGUA AND BARBUDA" , "ARGENTINA" ,
    "ARMENIA" , "ARUBA" , "AUSTRALIA" , "AUSTRIA" , "AZERBAIJAN" , "BAHAMAS" , "BAHRAIN" ,
    "BANGLADESH" , "BARBADOS" , "BELARUS" , "BELGIUM" , "BELIZE" , "BENIN" , "BERMUDA" ,
    "BHUTAN" , "BOLIVIA" , "BOSNIA AND HERZEGOWINA" , "BOTSWANA" , "BOUVET ISLAND" , "BRAZIL" ,
    "BRITISH INDIAN OCEAN TERRITORY" , "BRUNEI DARUSSALAM" , "BULGARIA" , "BURKINA FASO" , "BURUNDI" ,
    "CAMBODIA" , "CAMEROON" , "CANADA" , "CAPE VERDE" , "CAYMAN ISLANDS" , "CENTRAL AFRICAN REPUBLIC" ,
    "CHAD" , "CHILE" , "CHINA" , "CHRISTMAS ISLAND" , "COCOS ISLANDS" , "COLOMBIA" , "COMOROS" , "CONGO" ,
    " Democratic Republic of" , "CONGO" , " Republic of" , "COOK ISLANDS" , "COSTA RICA" , "COTE D'IVOIRE" ,
    "CROATIA" , "CUBA" , "CYPRUS" , "CZECH REPUBLIC" , "DENMARK" , "DJIBOUTI" , "DOMINICA" , "DOMINICAN REPUBLIC" ,
    "ECUADOR" , "EGYPT" , "EL SALVADOR" , "EQUATORIAL GUINEA" , "ERITREA" , "ESTONIA" , "ETHIOPIA" , "FALKLAND ISLANDS" ,
    "FAROE ISLANDS" , "FIJI" , "FINLAND" , "FRANCE" , "FRENCH GUIANA" , "FRENCH POLYNESIA" , "FRENCH SOUTHERN TERRITORIES" ,
    "GABON" , "GAMBIA" , "GEORGIA" , "GERMANY" , "GHANA" , "GIBRALTAR" , "GREECE" , "GREENLAND" , "GRENADA" , "GUADELOUPE" ,
    "GUAM" , "GUATEMALA" , "GUINEA" , "GUINEA-BISSAU" , "GUYANA" , "HAITI" , "HEARD AND MC DONALD ISLANDS" , "HONDURAS" ,
    "HONG KONG" , "HUNGARY" , "ICELAND" , "INDIA" , "INDONESIA" , "IRAN" , "IRAQ" , "IRELAND" , "ISRAEL" , "ITALY" , "JAMAICA" ,
    "JAPAN" , "JORDAN" , "KAZAKHSTAN" , "KENYA" , "KIRIBATI" , "KOREA" , " DEMOCRATIC PEOPLE'S REPUBLIC OF" , "KOREA" ,
    " REPUBLIC OF" , "KUWAIT" , "KYRGYZSTAN" , "LAO PEOPLE'S DEMOCRATIC REPUBLIC" , "LATVIA" , "LEBANON" , "LESOTHO" ,
    "LIBERIA" , "LIBYAN ARAB JAMAHIRIYA" , "LIECHTENSTEIN" , "LITHUANIA" , "LUXEMBOURG" , "MACAU" , "MACEDONIA" ,
    " THE FORMER YUGOSLAV REPUBLIC OF" , "MADAGASCAR" , "MALAWI" , "MALAYSIA" , "MALDIVES" , "MALI" , "MALTA" ,
    "MARSHALL ISLANDS" , "MARTINIQUE" , "MAURITANIA" , "MAURITIUS" , "MAYOTTE" , "MEXICO" , "MICRONESIA" ,
    " FEDERATED STATES OF" , "MOLDOVA" , " REPUBLIC OF" , "MONACO" , "MONGOLIA" , "MONTSERRAT" , "MOROCCO" ,
    "MOZAMBIQUE" , "MYANMAR" , "NAMIBIA" , "NAURU" , "NEPAL" , "NETHERLANDS" , "NETHERLANDS ANTILLES" ,
    "NEW CALEDONIA" , "NEW ZEALAND" , "NICARAGUA" , "NIGER" , "NIGERIA" , "NIUE" , "NORFOLK ISLAND" ,
    "NORTHERN MARIANA ISLANDS" , "NORWAY" , "OMAN" , "PAKISTAN" , "PALAU" , "PALESTINIAN TERRITORY" ,
    " Occupied" , "PANAMA" , "PAPUA NEW GUINEA" , "PARAGUAY" , "PERU" , "PHILIPPINES" , "PITCAIRN" ,
    "POLAND" , "PORTUGAL" , "PUERTO RICO" , "QATAR" , "REUNION" , "ROMANIA" , "RUSSIAN FEDERATION" ,
    "RWANDA" , "SAINT HELENA" , "SAINT KITTS AND NEVIS" , "SAINT LUCIA" , "SAINT PIERRE AND MIQUELON" ,
    "SAINT VINCENT AND THE GRENADINES" , "SAMOA" , "SAN MARINO" , "SAO TOME AND PRINCIPE" , "SAUDI ARABIA" ,
    "SENEGAL" , "SERBIA AND MONTENEGRO" , "SEYCHELLES" , "SIERRA LEONE" , "SINGAPORE" , "SLOVAKIA" , "SLOVENIA" ,
    "SOLOMON ISLANDS" , "SOMALIA" , "SOUTH AFRICA" , "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS" , "SPAIN" ,
    "SRI LANKA" , "SUDAN" , "SURINAME" , "SVALBARD AND JAN MAYEN ISLANDS" , "SWAZILAND" , "SWEDEN" , "SWITZERLAND" ,
    "SYRIAN ARAB REPUBLIC" , "TAIWAN" , "TAJIKISTAN" , "TANZANIA" , " UNITED REPUBLIC OF" , "THAILAND" , "TIMOR-LESTE" ,
    "TOGO" , "TOKELAU" , "TONGA" , "TRINIDAD AND TOBAGO" , "TUNISIA" , "TURKEY" , "TURKMENISTAN" , "TURKS AND CAICOS ISLANDS" ,
    "TUVALU" , "UGANDA" , "UKRAINE" , "UNITED ARAB EMIRATES" , "UNITED KINGDOM" , "UNITED STATES" ,
    "UNITED STATES MINOR OUTLYING ISLANDS" , "URUGUAY" , "UZBEKISTAN" , "VANUATU" , "VATICAN CITY STATE" , "VENEZUELA" ,
    "VIET NAM" , "VIRGIN ISLANDS" , "VIRGIN ISLANDS" , "WALLIS AND FUTUNA ISLANDS" , "WESTERN SAHARA" , "YEMEN" , "ZAMBIA" ,
    "ZIMBABWE"]


  static SERVER_URL() {
    if (environment.production) {
      return Constants.prodServerUrl;
    }
    return Constants.serverUrl;
  }

  static TENANT_ID() {
    return Constants.tenantId;
  }

  static ORIGIN() {
    return Constants.origin;
  }

  static BUCKET_URL() {
    return Constants.bucketUrl;
  }

  static TENANT_BUCKET() {
    return Constants.bucketUrl + Constants.tenantId + '/';
  }

  static IS_MOTHERSHIP_TENANT() {
    return Constants.tenantId === this.MOTHERSHIP_TENANT();
  }

  static MOTHERSHIP_TENANT() {
    return environment.motherShipTenant;
  }

  static POST_AFFILIATE_PRO_URL() {
    return Constants.postAffiliateProUrl;
  }

  static COUNTRIES() {
    return Constants.countries;
  }
  static TAWK_TO() {
    return environment.tawk_to;
  }

  static setup(window: any) {
    let baseURI: string = window.origin;
    if (typeof baseURI !== 'string') {
      /*Fallback for cross browsers*/
      baseURI = (window.document.URL || ((window.document.location) ? window.document.location.href : window.document.baseURI));
    }
    Constants.tenantId = baseURI.split(':')[1].replace('//',
      '').replace('www.',
      '').split('/')[0];
    Constants.origin = 'https://' + Constants.tenantId;
  }

  static IP_GEO_LOCATION_URL() {
    return environment.ipGeoLocationUrl;
  }

  static SAASMAX_PARTNER_EMAIL() {
    return environment.partnerEmail;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/constants.ts